import { createSelector } from 'reselect';

import { getCatalog } from './getCatalog';

export const getSelectedPartId = createSelector(
  getCatalog,
  catalog => catalog.selectedPartId
);
